module.exports = __webpack_public_path__ + "img/loginRegister.b071744f.png";